<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">
        {{ $t("Distributor Collection Report") }}
      </div>

      <div class="mt-3 border-bottom">
        <div class="row">
          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="fromDate"
                  @selected="onSelectDate()"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">Show From Date</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  @selected="onSelectDate()"
                  v-model="toDate"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <!-- disabled -->
                <label :class="toDate ? 'active' : ''">Show To Date</label>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label :class="selectedCinema ? 'shift-up' : ''">
                  {{ "Select Cinema" }}
                </label>

                <multiselect
                  v-model="selectedCinema"
                  @select="onSelectHandler($event, 'cinema')"
                  @remove="onRemoveHandler($event, 'cinema')"
                  placeholder=""
                  :options="Cinemas"
                  label="cine_name"
                  track-by="cine_id"
                  :multiple="false"
                  name="cine_id"
                  id="cine_id"
                  select-label="Select"
                  deselect-label="Remove"
                >
                </multiselect>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label
                  :class="selectedDistributor.length > 0 ? 'shift-up' : ''"
                >
                  {{ "Distributor" }}
                </label>

                <multiselect
                  v-model="selectedDistributor"
                  @input="onSelectHandler($event, 'distributor')"
                  @remove="onRemoveHandler($event, 'distributor')"
                  placeholder=""
                  :options="getDistributorReportDropdownList"
                  label="d_company_name"
                  track-by="d_id"
                  :multiple="true"
                  name="d_id"
                  id="d_id"
                  select-label="Select"
                  deselect-label="Remove"
                >
                </multiselect>
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="d-flex align-items-center">
              <div class="dropdown-curve-container">
                <label :class="selectedMovie.length > 0 ? 'shift-up' : ''">
                  {{ "Movie" }}
                </label>

                <multiselect
                  v-model="selectedMovie"
                  @select="onSelectHandler($event, 'movie')"
                  @remove="onRemoveHandler($event, 'movie')"
                  placeholder=""
                  :options="MovieList"
                  label="movie_title"
                  track-by="movie_id"
                  :multiple="true"
                  name="movie_id"
                  id="movie_id"
                  select-label="Select"
                  deselect-label="Remove"
                >
                </multiselect>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent.stop="fDistributorReportList"
            >
              {{ $tc("Fetch Report") }}
            </button>
          </div>

          <!--  -->
          <div
            v-if="DistributorCollection.length > 0 && validateTicketCount > 0"
            class="d-flex justify-content-end align-items-center col-lg-6 col-xl-3 align-self-center mb-3"
          >
            <div class="mr-2">Download as:</div>
            <a
              v-if="PDFName"
              :href="BASE_URL + PDFName"
              target="_blank"
              download
              title="Download as PDF"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>

            <a
              v-if="ExcelName"
              :href="BASE_URL + ExcelName"
              target="_blank"
              title="Download as Excel"
              download
            >
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </a>
          </div>
        </div>
      </div>
      <div class="swc-report" v-if="DistributorCollection.length == 0">
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th class="text-left">Distributor</th>
              <th class="text-left">Movie Name</th>
              <th class="text-left">Show Date</th>
              <th>Show Time</th>
              <th>Screen</th>
              <th>Class</th>
              <th>Ticket Type</th>
              <th>No of Tkts</th>
              <th v-if="selectedTable.table_name == 'With Complimentary'">
                Comp. Tkts
              </th>
              <th v-if="selectedTable.table_name == 'With Complimentary'">
                Total Tkts
              </th>
              <th v-if="selectedTable.table_name == 'With Complimentary'">
                VAT
              </th>
              <th v-if="selectedTable.table_name == 'With Complimentary'">
                M-Tax
              </th>
              <th>Price/Tkt</th>
              <th>Amt(incl Tax)</th>
              <th>Tax</th>
              <th class="_net2">{{ "Net Amt" }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="17">
                <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        v-if="DistributorCollection.length > 0"
        class="swc-report table-scroll"
      >
        <table class="swc-report-table" border="1">
          <thead>
            <tr>
              <th class="text-left">Distributor</th>
              <th class="text-left">Movie Name</th>
              <th class="text-left">Show Date</th>
              <th>Screen</th>
              <th>Show Time</th>
              <!-- <th>Class</th>
              <th>Ticket Type</th> -->
              <th>No of Tkts</th>
              <th>Comp. Tkts</th>
              <th>Price/Tkt</th>
              <th>Amt(incl Tax)</th>
              <!-- <th>TAX</th> -->
              <th>VAT</th>
              <th>M-Tax</th>
              <th>Dist %</th>
              <th>Dist.Comm</th>
              <th class="_net2">{{ "Net Amt" }}</th>
            </tr>
          </thead>

          <tbody>
            <template
              v-for="(item, itemIndex) in DistributorCollection"
              class="mb-5"
            >
              <template v-for="disMovie in item">
                <tr v-for="(show, showIndex) in disMovie.Data" :key="showIndex">
                  <td
                    class="text-left"
                    v-if="showIndex == 0"
                    :rowSpan="disMovie.Data.length"
                  >
                    {{ show.dist_company_name }}
                  </td>
                  <td
                    class="text-left"
                    v-if="showIndex == 0"
                    :rowSpan="disMovie.Data.length"
                  >
                    {{ show.movie_name }}
                  </td>
                  <td class="text-left">
                    {{
                      show.display_date
                        ? moment(show.display_date, "DD-MM-YYYY").format(
                            "DD-MMM-YYYY"
                          )
                        : show.show_date
                    }}
                    ({{
                      show.ss_actual_start_date
                        ? moment(show.ss_actual_start_date).format(
                            "DD-MMM-YYYY"
                          )
                        : show.show_date
                    }})
                  </td>
                  <td>{{ show.screen_name }}</td>
                  <td>
                    {{ moment(show.t_show_time, "HH:mm").format("hh:mm a") }}
                  </td>
                  <!-- <td>{{ show.seat_type_name }}</td>
                  <td>{{ show.ticket_type_name }}</td> -->
                  <td>{{ show.Sold }}</td>
                  <td>
                    {{ show.compplementory_ticket || 0 }}
                  </td>
                  <td>{{ currFormat(show.rate) }}</td>
                  <td>
                    {{
                      checkClientName()
                        ? show["final_gross_amount"]
                          ? currFormat(show["final_gross_amount"])
                          : "-"
                        : show["gross_amount"]
                        ? currFormat(show["gross_amount"])
                        : "-"
                    }}
                  </td>

                  <!-- <td>{{ currFormat(show["total_taxes2"]) }}</td> -->
                  <td>
                    {{
                      hasCharge(show, "VAT")
                        ? currFormat(chargeAmount(show, "VAT"))
                        : "-"
                    }}
                  </td>
                  <td>
                    {{
                      hasCharge(show, "M-TAX")
                        ? currFormat(chargeAmount(show, "M-TAX"))
                        : "-"
                    }}
                  </td>
                  <td>{{ currFormat(show["distributorShareInPercent"]) }}</td>
                  <td>{{ currFormat(show["distributorShare"]) }}</td>
                  <td class="_net2">{{ currFormat(show["net_revenue2"]) }}</td>
                </tr>
              </template>
              <tr :key="itemIndex" class="color-blue">
                <th colspan="1">Final Total</th>
                <th colspan="1">No. of Shows = {{ item.length }}</th>
                <th colspan="3"></th>
                <th>
                  {{
                    item.reduce(function (a, b) {
                      b.Data.forEach(function (c) {
                        a += c.Sold;
                      });
                      return a;
                    }, 0) || "-"
                  }}
                </th>
                <th>
                  {{
                    item.reduce(function (a, b) {
                      b.Data.forEach(function (c) {
                        a += c.compplementory_ticket;
                      });
                      return a;
                    }, 0)
                  }}
                </th>

                <th></th>
                <th>
                  {{
                    checkClientName()
                      ? currFormat(
                          item.reduce(function (a, b) {
                            b.Data.forEach(function (c) {
                              a += parseFloat(c.final_gross_amount);
                            });
                            return a;
                          }, 0)
                        )
                      : currFormat(
                          item.reduce(function (a, b) {
                            b.Data.forEach(function (c) {
                              a += parseFloat(c.gross_amount);
                            });
                            return a;
                          }, 0)
                        ) || "-"
                  }}
                </th>
                <!-- <th>
                  {{
                    currFormat(
                      item.reduce(function (a, b) {
                        b.Data.forEach(function (c) {
                          a += parseFloat(c.total_taxes2);
                        });

                        return a;
                      }, 0) + 0
                    )
                  }}
                </th> -->
                <th>
                  {{
                    currFormat(
                      item.reduce(function (a, b) {
                        b.Data.forEach(function (c) {
                          a += chargeAmount(c, "VAT");
                        });

                        return a;
                      }, 0) + 0
                    )
                  }}
                </th>
                <th>
                  {{
                    currFormat(
                      item.reduce(function (a, b) {
                        b.Data.forEach(function (c) {
                          a += chargeAmount(c, "M-TAX");
                        });

                        return a;
                      }, 0) + 0
                    )
                  }}
                </th>
                <th></th>
                <th>
                  {{
                    currFormat(
                      item.reduce(function (a, b) {
                        b.Data.forEach(function (c) {
                          a += parseFloat(c.distributorShare);
                        });
                        return a;
                      }, 0)
                    )
                  }}
                </th>
                <th class="_net2">
                  {{
                    currFormat(
                      item.reduce(function (a, b) {
                        b.Data.forEach(function (c) {
                          a += parseFloat(c.net_revenue2);
                        });
                        return a;
                      }, 0)
                    ) || "-"
                  }}
                </th>
              </tr>
              <tr :key="itemIndex" style="height: 40px"></tr>
            </template>
          </tbody>
        </table>
      </div>

      <hr class="my-2" />
      <div class="d-flex justify-content-between">
        <div
          v-if="
            complementaryFinalTable.length > 0 &&
            selectedTable.table_name == 'With Complimentary'
          "
          class="section-title mb-3"
        >
          complimentary Summary
        </div>
        <div
          v-if="
            complementaryFinalTable.length > 0 &&
            selectedTable.table_name == 'With Complimentary'
          "
          class="d-flex justify-content-end mt-2 align-items-center"
        >
          <div class="mr-2">Download as:</div>
          <img
            @click="excelDownload()"
            class="mx-1"
            src="@/assets/img/icons/excel.svg"
            height="25"
            width="25"
          />
        </div>
      </div>

      <div
        class="mt-2"
        style="text-align: right"
        v-if="
          complementaryFinalTable.length > 0 &&
          selectedTable.table_name == 'With Complimentary'
        "
      >
        <!-- <a target="_blank" title="Download as Excel" @click="excelDownload()">
            Download <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
      </a> -->
        <!-- <a target="_blank" @click="generateReport()" title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a> -->
      </div>
      <div
        v-if="
          complementaryFinalTable.length > 0 &&
          selectedTable.table_name == 'With Complimentary'
        "
        class="swc-report table-scroll"
      >
        <table class="swc-report-table" border="1">
          <thead class="color-blue font-weight-bold">
            <tr>
              <th>Distributor</th>
              <th>Cinema Name</th>
              <th>Movie Name</th>
              <th>Show Date</th>
              <th>Screen</th>
              <th>Show Time</th>
              <th>Comp. Tickets</th>
              <th>Price/Tkt</th>
              <th>Amt(Incl. Tax)</th>
            </tr>
          </thead>
          <template
            v-for="(summaryData, summaryDataIndex) in complementaryFinalTable"
          >
            <tr :key="summaryDataIndex + 'SummaryData'">
              <td
                class="text-left"
                :rowspan="summaryData.price_details.length + 1"
              >
                {{ summaryData.dist_company_name }}
              </td>
              <td
                class="text-left"
                :rowspan="summaryData.price_details.length + 1"
              >
                {{ summaryData.cinema_name }}
              </td>
              <td
                class="text-left"
                :rowspan="summaryData.price_details.length + 1"
              >
                {{ summaryData.movie_name }}
              </td>
              <td
                class="text-left"
                :rowspan="summaryData.price_details.length + 1"
              >
                {{ summaryData.show_date }}
              </td>
              <td
                class="text-left"
                :rowspan="summaryData.price_details.length + 1"
              >
                {{ summaryData.screen_name }}
              </td>
              <td
                class="text-left"
                :rowspan="summaryData.price_details.length + 1"
              >
                {{ summaryData.t_show_time }}
              </td>
            </tr>
            <template
              v-for="(compData, compDataIndex) in summaryData.price_details"
            >
              <tr :key="compDataIndex + 'compData'">
                <td class="text-right">{{ compData.complimentary_count }}</td>
                <td class="text-right">
                  {{ compData.rate.toFixed(this.MIN_FRACTION_DIGITS) }}
                </td>
                <td class="text-right">
                  {{ compData.totalRate.toFixed(this.MIN_FRACTION_DIGITS) }}
                </td>
              </tr>
            </template>
          </template>
          <tr class="color-blue font-weight-bold">
            <td class="text-left" colspan="6">Total</td>
            <td class="text-right">{{ complementaryGrandTotal.comp_total }}</td>
            <td class="text-right"></td>
            <td class="text-right">
              {{
                complementaryGrandTotal.comp_rate_total.toFixed(
                  this.MIN_FRACTION_DIGITS
                )
              }}
            </td>
            <!-- <td class="text-right">
              {{ complementaryGrandTotal.price_total }}
            </td> -->
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { Role, CLIENT_NAME } from "@/helper/Role";
import { mapState, mapGetters, mapActions } from "vuex";
import { movieWeekEnd } from "@/helper/collection";
import moment from "moment";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService";
import { authenticationService } from "@/services/AuthenticationService";
import xlsx from "json-as-xlsx";

export default {
  data() {
    return {
      CLIENT_NAME,
      FilePathArray: [],
      MovieList: [],
      PDFName: "",
      ExcelName: "",
      DistributorCollection: [],
      FinalTotalCharges: [],
      Cinemas: [],
      selectedCinema: "",
      cinema_id: null,
      selectedDistributor: [],
      d_id: null,
      selectedMovie: [],
      movie_id: null,
      fromDate: new Date(),
      toDate: new Date(),
      isRoleID: true,
      CinemasCopy: [],
      searchCinema: "",
      complementaryCheckStatus: "N",
      complementarySummaryTable: [],
      complementaryFinalTable: [],
      complementaryGrandTotal: {
        comp_total: 0,
        price_total: 0,
      },
      selectedTable: {
        table_id: 1,
        table_name: "Without Complimentary",
      },
      selectedTableDropDown: [
        {
          table_id: 1,
          table_name: "Without Complimentary",
        },
        // {
        //   table_id: 2,
        //   table_name: "With Complimentary",
        // },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getDistributorReportDropdownList",
      //   "getDistributorReportMoviesList",
    ]),
    distributorIds() {
      let text = ``;
      if (this.selectedDistributor.length > 0) {
        text = this.selectedDistributor.map((x) => x.d_id).join(",");
      }

      return text;
    },
    movieIds() {
      let text = ``;
      if (this.selectedMovie.length > 0) {
        text = this.selectedMovie.map((x) => x.md_id).join(",");
      }

      return text;
    },
    validateTicketCount() {
      let count = 0;
      this.DistributorCollection.map((x) => {
        x.map((y) => {
          y.Data.map((z) => {
            count += parseFloat(z.Sold);
          });
        });
      });
      return count;
    },
  },
  beforeMount() {
    if (this.CLIENT_SETUP_NAME == CLIENT_NAME.EPIX) {
      this.$router.push({
        path: "/reports/cinema-reports/distributor-report-epix",
      });
    }
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let distributorId = this.secureStore.get("USINFO")["distributor_id"];
    console.log("dis::::::::::::: :", distributorId);
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.onSelectHandler(CinemaObj, "cinema");
    }

    // if (distributorId) {
    //   this.onDistributorReportFlagHandler({
    //     event: null,
    //     name: "isDistributor",
    //     value: distributorId
    //   });
    // }
    // this.fetchCinemasList({ cinemaId });
    this.fetchReportDistributorsList();
  },
  methods: {
    moment,
    // The API keys each charge on the row as `${ct_name}_${ct_id}` using the
    // spelling stored in ms_charge_types - e.g. "M-TAX_2", not "M-Tax_2".
    // Matching that name case-insensitively keeps the column working whoever
    // capitalises the charge, instead of silently reading 0.
    chargeKey(row, chargeName) {
      if (!row) return null;
      let wanted = String(chargeName).toUpperCase();

      return (
        Object.keys(row).find(key => {
          let separator = key.lastIndexOf("_");

          return separator > 0 && key.slice(0, separator).toUpperCase() === wanted;
        }) || null
      );
    },
    hasCharge(row, chargeName) {
      return !!this.chargeKey(row, chargeName);
    },
    chargeAmount(row, chargeName) {
      let key = this.chargeKey(row, chargeName);

      return key ? parseFloat(row[key]) || 0 : 0;
    },
    checkClientName() {
      console.log(CLIENT_NAME.EMPIRE, this.CLIENT_SETUP_NAME);
      return CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME;
    },
    onSelectDate() {
      this.selectedDistributor = [];
      this.selectedMovie = [];
      this.$forceUpdate();
    },
    onRemoveHandler(event, type) {
      if (type == "cinema") {
        this.cinema_id = null;
        this.selectedCinema = "";
      } else if (type == "distributor") {
        this.d_id = null;
        // this.selectedDistributor = [];
      } else if (type == "movie") {
        this.movie_id = null;
        // this.selectedMovie = [];
      }
    },
    onSearchCinema: function () {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter((x) => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getCinemaList: function (cine_id) {
      this.Cinemas = [];
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
            this.Cinemas.map((x) => {
              if (String(cine_id) === String(x.cine_id)) {
                this.onDistributorReportFlagHandler({
                  event: null,
                  name: "isCinema",
                  value: x.cine_id,
                  cine_name: x.cine_name,
                });
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    fetchDistributorMovies() {
      if (!this.cinema_id) {
        this.$toasted.show("Please Select Cinema");
        this.selectedDistributor = [];
        this.$forceUpdate();
      } else {
        this.MovieList = [];
        let payload = {
          fromDate: this.fromDate,
          toDate: this.toDate,
          cinema_id: this.cinema_id,
          cinema_name: this.selectedCinema.cine_name,
          d_id: this.distributorIds,
          d_company_name: this.selectedDistributor
            .map((x) => x.d_company_name)
            .join(","),
          country_id: authenticationService.get("BRGLOPCO"),
          filter_with_key: "ss_actual_start_date",
        };
        ReportsService.GetDistributorMovieFormat(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records) {
              this.MovieList = data.Records;
            } else
              this.$toasted.show(data.message || "Opps! Something went wrong");
          })
          .catch((error) => {
            this.$toasted.show(
              "Catch Error on ReportStore fetchDistributorMovies",
              error
            );
          });
      }
    },
    onSelectHandler(event, type) {
      if (type == "cinema") {
        this.cinema_id = event.cine_id;
        this.selectedCinema = event;
        this.$store.dispatch("selectDropdownCinema", event);
      } else if (type == "distributor") {
        this.d_id = event.d_id;
        this.selectedMovie = [];
        this.MovieList = [];
        this.fetchDistributorMovies();
        // this.selectedDistributor = event;
      } else if (type == "movie") {
        this.movie_id = event.md_id;
        // this.selectedMovie = event;
      }
    },
    fDistributorReportList: async function () {
      this.DistributorCollection = [];
      console.log("this.fromDate", this.fromDate);
      console.log("this.toDate", this.toDate);
      let fromDate = moment(new Date(this.fromDate)).format("YYYY-MM-DD");
      let toDate = moment(new Date(this.toDate)).format("YYYY-MM-DD");

      console.log("fromDate", fromDate);
      console.log("toDate", toDate);

      if (new Date(fromDate) > new Date(toDate)) {
        this.$toasted.show("From date should not be greater than To date.");
      } else if (!this.cinema_id) {
        this.$toasted.show("Please Select any Cinema.");
      } else {
        let loader = this.$loading.show();
        let payload = {
          fromDate: fromDate,
          toDate: toDate,
          cinema_id: this.cinema_id,
          cinema_name: this.selectedCinema.cine_name,
          d_id: this.distributorIds,
          d_company_name: this.selectedDistributor
            .map((x) => x.d_company_name)
            .join(","),
          movie_id: this.movieIds,
          movie_title: this.selectedMovie.map((x) => x.movie_title).join(","),
          country_id: authenticationService.get("BRGLOPCO"),
          noDataInDateRange: false,
          weekWithNoSchedule: false,
          filter_with_key: "ss_actual_start_date",
          isComplementary: "N",
        };
        console.log("payload", payload.isComplementary);

        ReportsService.GetDistributorCollectionReportV5(payload)
          .then(async (response) => {
            const { data } = response;
            if (data && data.status && data.data) {
              // if (data && data.data.length > 0) {
              //   data.data.forEach(
              //     d1 => {
              //       if (d1.length) {
              //         d1.forEach(
              //           d => {
              //             if (d.Data && d.Data.length) {
              //               d.Data.forEach(
              //                 s => {
              //                   let gcamKey = Object.keys(s).filter(k => String(k.toUpperCase()).includes('GCAM'))
              //                   if (gcamKey.length) {
              //                     s.t_gcam = s[gcamKey[0]] || 0
              //                   } else {
              //                     s.t_gcam = 0
              //                   }
              //
              //                   let vatKey = Object.keys(s).filter(k => String(k.toUpperCase()).includes('VAT'))
              //                   if (vatKey.length) {
              //                     s.t_vat = 0
              //                     vatKey.forEach(k => {
              //                       s.t_vat += (s[k] || 0)
              //                     })
              //                   }
              //                 }
              //               )
              //             }
              //           }
              //         )
              //       }
              //     }
              //   )
              // }

              this.DistributorCollection = data.data;
              this.FinalTotalCharges = [];
              this.complementaryFinalTable = [];

              //summary table for complimentary tickets
              if (this.selectedTable.table_name == "With Complimentary") {
                // data.data.map(a => {
                //   a.map(b => {
                //     if (b.Data.length) {
                //       b.Data.map(c => {
                //         if (c.compplementory_ticket > 0) {
                //           this.DistributorCollection.push(a);
                //         }
                //       });
                //     }
                //   });
                // });
                // this.DistributorCollection = [...test_arr];
                if (this.DistributorCollection.length) {
                  this.complementarySummaryTable = [];
                  let summaryTableInitialArr = this.complementarySummaryTable;
                  this.DistributorCollection.map((_dcArray1) => {
                    _dcArray1.map((_dcArray2) => {
                      _dcArray2.Data.map((x) => {
                        if (x.compplementory_ticket > 0) {
                          summaryTableInitialArr.push(x);
                        }
                      });
                    });
                  });
                  // let summaryTableFinalArr = [];
                  let summaryTableFinalArr = this.complementaryFinalTable;
                  summaryTableInitialArr.map((initialMap) => {
                    let findMovieIndex = summaryTableFinalArr.findIndex(
                      (indexObj) => {
                        return (
                          indexObj.movie_id == initialMap.movie_id &&
                          indexObj.show_date == initialMap.show_date &&
                          indexObj.t_show_time == initialMap.t_show_time &&
                          indexObj.screen_id == initialMap.screen_id &&
                          indexObj.cinema_id == initialMap.cinema_id &&
                          indexObj.d_id == initialMap.d_id
                        );
                      }
                    );
                    if (findMovieIndex < 0) {
                      let obj = {
                        movie_id: initialMap.movie_id,
                        show_date: initialMap.show_date,
                        t_show_time: initialMap.t_show_time,
                        screen_id: initialMap.screen_id,
                        t_show_time: initialMap.t_show_time,
                        d_id: initialMap.d_id,
                        dist_company_name: initialMap.dist_company_name,
                        screen_name: initialMap.screen_name,
                        movie_name: initialMap.movie_name,
                        cinema_name: initialMap.cinema_name,
                        price_details: [],
                      };
                      obj["price_details"].push({
                        rate: initialMap.rate,
                        complimentary_count: initialMap.compplementory_ticket,
                        totalRate:
                          initialMap.rate * initialMap.compplementory_ticket,
                      });
                      summaryTableFinalArr.push(obj);
                    } else {
                      let findPriceIndex = summaryTableFinalArr[findMovieIndex][
                        "price_details"
                      ].findIndex((priceIndex) => {
                        return priceIndex.rate == initialMap.rate;
                      });
                      summaryTableFinalArr["totalAmt"] += initialMap.rate;
                      if (findPriceIndex >= 0) {
                        summaryTableFinalArr[findMovieIndex]["price_details"][
                          findPriceIndex
                        ]["rate"] += +parseFloat(initialMap.rate);
                        summaryTableFinalArr[findMovieIndex]["price_details"][
                          findPriceIndex
                        ]["complimentary_count"] += +parseFloat(
                          initialMap.compplementory_ticket
                        );
                        summaryTableFinalArr[findMovieIndex]["price_details"][
                          findPriceIndex
                        ]["totalRate"] =
                          initialMap.rate * initialMap.compplementory_ticket;
                      } else {
                        summaryTableFinalArr[findMovieIndex][
                          "price_details"
                        ].push({
                          rate: initialMap.rate,
                          complimentary_count: initialMap.compplementory_ticket,
                          totalRate:
                            initialMap.rate * initialMap.compplementory_ticket,
                        });
                      }
                      // summaryTableFinalArr[findMovieIndex][
                      //   "complimentary_details"
                      // ].push(initialMap.compplementory_ticket);
                    }
                  });
                  if (this.complementaryFinalTable.length) {
                    this.complementaryGrandTotal = {
                      price_total: 0,
                      comp_total: 0,
                      comp_rate_total: 0,
                    };
                    this.complementaryFinalTable.map((compDataArr1) => {
                      compDataArr1.price_details.reduce((acc, { rate }) => {
                        return (this.complementaryGrandTotal.price_total +=
                          acc + rate);
                      }, 0);
                      compDataArr1.price_details.reduce(
                        (acc, { complimentary_count }) => {
                          return (this.complementaryGrandTotal.comp_total +=
                            acc + complimentary_count);
                        },
                        0
                      );
                      compDataArr1.price_details.reduce(
                        (acc, { complimentary_count, rate }) => {
                          return (this.complementaryGrandTotal.comp_rate_total +=
                            acc + complimentary_count * rate);
                        },
                        0
                      );
                    });
                  }
                }
              }
              if (data.PDFName) {
                this.PDFName = data.PDFName;
                this.FilePathArray.push(data.PDFName);
              }
              if (data.ExcelName) {
                this.ExcelName = data.ExcelName;
                this.FilePathArray.push(data.ExcelName);
              }
            } else {
              this.toasted.show(data.message);
            }
          })
          .catch((error) => {
            console.log("ERROR:", error);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      }
    },
    ...mapActions([
      // FETCH FROM MASTER STORE
      "fetchCinemasList",
      // "fetchDistributorsList",
      // "fetchDistributorsActiveMasterMovie",
      // FETCH LIST ONLY
      "fetchReportDistributorsList",
      "fetchDistributorReportList",
      "onDistributorReportDateHandler",
      "onDistributorReportDropdownHandler",
      "onDistributorReportFlagHandler",
      "onResetDistributorStoreState",
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/distributoCollectionReportV5.vue